import { ContainerReflection } from 'typedoc/dist/lib/serialization/schema';

export const pi: ContainerReflection = require('@mkanai/casetivity-shared-js/docs/pi.json');
export const functionNames = pi.children.map((e) => e.name);
